import {
  Grid,
  AppBar,
  Toolbar,
  Button,
  Alert,
  Snackbar,
  Box,
} from "@mui/material";
import "rsuite/dist/rsuite.min.css";
import { DateRangePicker } from "rsuite";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Loading from "../Dashboard/Loading";
import { useLocation, useParams } from "react-router-dom";
import { format } from "date-fns";
import { Stack } from "@mui/joy";
import { Typography } from "@material-ui/core";
import { FormatNumber } from "../../utils/formatNumber";
import Datefilter from "../../utils/Datefilter";
import { purchaseVariables, redemptionVariables } from "../../Data/data";
import { saveAs } from "file-saver";
import { Download } from "@mui/icons-material";

export default function TransactionDatewise({ accessToken }) {
  const ViewDate = (str) => {
    var date = new Date(str);
    var mnth = date.getMonth();
    var day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    return `${day}-${mnth}-${year}`;
  };

  const { folio } = useParams();
  const { state }: any = useLocation();
  const [tranx, setTranx] = useState<any>([]);
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [columns, setColumns] = useState([
    {
      field: "id",
      headerName: "S.No",
      width: 90,
      renderHeader: () => <strong>{"S.No"}</strong>,
    },
    {
      field: "SCHEME_NAME",
      headerName: "Fund",
      width: 380,
      renderHeader: () => <strong>{"Fund"}</strong>,
      renderCell: (params) => {
        let { SCHEME_NAME } = params.row;
        // const schemName = SCHEME_NAME?.split("/")[1];
        return (
          <div
            style={{
              minHeight: "50px",
              alignItems: "center",
              display: "flex",
              width: "100%",
            }}
          >
            {SCHEME_NAME}
          </div>
        );
      },
    },
    {
      field: "TRXN_TYPE",
      headerName: "Transaction Type",
      width: 240,
      renderHeader: () => <strong>{"Transaction Type"}</strong>,
      renderCell: (params) => {
        let { TRXN_TYPE } = params.row;
        const TransactionType = purchaseVariables.test(TRXN_TYPE)
          ? "Purchase"
          : redemptionVariables.test(TRXN_TYPE)
          ? "Redemption"
          : TRXN_TYPE;
        return <div>{TransactionType}</div>;
      },
    },
    {
      field: "UNITS",
      headerName: "Amount",
      width: 180,
      renderHeader: () => <strong>{"Amount / Units"}</strong>,
      renderCell: (params) => {
        const { UNITS, TRXN_STATUS, AMOUNT, TRXN_TYPE, ALL_UNITS } = params.row;

        let amount: any;

        if (TRXN_TYPE === "Redemption") {
          if (ALL_UNITS === "N") {
            const hasUnits = UNITS && UNITS !== "N/A";
            const hasAmount = AMOUNT != null && AMOUNT !== "";

            if (!hasUnits && !hasAmount) {
              amount = "N/A";
            } else if (hasUnits && hasAmount) {
              amount = `Rs ${FormatNumber(AMOUNT)} & ${FormatNumber(
                UNITS
              )} units`;
            } else if (hasAmount) {
              amount = `Rs ${FormatNumber(AMOUNT)}`;
            } else if (hasUnits) {
              amount = `${FormatNumber(UNITS)} units`;
            }
          } else {
            amount = "All units";
          }
        } else {
          amount = AMOUNT
            ? `Rs ${FormatNumber(AMOUNT)}`
            : "Confirmation Pending";
        }
        // const amount =
        //   TRXN_TYPE == "Redemption"
        //     ? ALL_UNITS == "N"
        //       ? UNITS === "N/A "
        //         ? "Confirmation Pending"
        //         : `${FormatNumber(UNITS)} units`
        //       : `All units`
        //     : AMOUNT
        //     ? `Rs ${FormatNumber(AMOUNT)}`
        //     : "Confirmation Pending";
        // TRXN_TYPE == "Redemption"
        //   ? ALL_UNITS == "No"
        //     ? `${FormatNumber(UNITS)} units`
        //     : `All units`
        //   : `Rs ${FormatNumber(AMOUNT)}`;
        if (TRXN_STATUS == "Pending") {
          // @ts-ignore
          return (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">{amount}</Typography>
              <Typography
                style={{ color: "#FDD017", textWrap: "wrap" }}
                variant="caption"
              >
                {TRXN_STATUS}
              </Typography>
            </Box>
          );
        } else if (TRXN_STATUS == "Rejected / Reversal") {
          // @ts-ignore
          return (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">{amount}</Typography>
              <Typography
                style={{ color: "red", textWrap: "wrap" }}
                variant="caption"
              >
                {TRXN_STATUS.split("/")[0]}
              </Typography>
            </Box>
          );
        } else {
          // @ts-ignore
          return (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">{amount}</Typography>
              <Typography
                style={{ color: "green", textWrap: "wrap" }}
                variant="caption"
              >
                {TRXN_STATUS}
              </Typography>
            </Box>
          );
        }
      },
    },
    {
      field: "REMARKS",
      headerName: "Order Remarks",
      width: 240,
      renderHeader: () => <strong>{"Order Remarks"}</strong>,
      renderCell: (params) => {
        let { REMARK } = params.row;
        if (REMARK.toLowerCase().includes("declined by the bank")) {
          REMARK = "DECLINED BY BANK";
        }
        return (
          <div
            style={{
              minHeight: "50px",
              display: "flex",
              justifyContent: "center", // Centering the text
              alignItems: "center", // Centering vertically
              width: "100%",
              textAlign: "center", // Optional: Center the text horizontally
            }}
          >
            {REMARK}
          </div>
        );
      },
    },
    {
      field: "PAYMENT_STATUS",
      headerName: "Payment Status",
      width: 240,
      renderHeader: () => <strong>{"Payment Status"}</strong>,
      renderCell: (params) => {
        let { PAYMENT_STATUS } = params.row;
        // if (REMARK.toLowerCase().includes("declined by the bank")) {
        //   REMARK = "DECLINED BY BANK";
        // }
        return <div>{PAYMENT_STATUS}</div>;
      },
    },
    {
      field: "AUTHORIZED_DATE_TIME",
      headerName: "Transaction Date",
      width: 240,
      renderHeader: () => <strong>{"Transaction Date"}</strong>,
    },
  ]);
  const today = new Date();
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(format(today, "MM/dd/yyyy"));
  const dateConverter = (str) => {
    const month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var date = new Date(str);
    var mnth = date.getMonth();
    var day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    return `${day}-${month[mnth]}-${year}`;
  };
  const [isDisable, SetisDisable] = useState(true);
  const [IntervalDate, setIntervalDate] = useState({
    startDate: dateConverter(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
    endDate: dateConverter(new Date().getTime()),
  });
  const [Interval, setInterval] = useState({
    startDate: dateConverter(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
    endDate: dateConverter(new Date().getTime()),
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [isDownloading, setDownloading] = useState(false);

  const getTranxData = async () => {
    setLoading(true);
    const startDate = new Date(IntervalDate.startDate).getTime();
    const endDate = new Date(IntervalDate.endDate).getTime();
    const diff = endDate - startDate;
    const ThirtyDays = 1000 * 60 * 60 * 24 * 30;
    console.log(endDate - startDate);
    if (diff > ThirtyDays) {
      setLoading(false);
      setMessage("Difference between the dates cannot be more than 30 days");
      setError(true);
      return;
    }

    try {
      const res = axios
        .post(
          `${process.env.REACT_APP_BACKEND_HOST}v1/super/nse/transaction`,
          {
            iin: folio,
            from_date: IntervalDate.startDate,
            to_date: IntervalDate.endDate,
            triggered_trxn: "N",
            initiated_by: "B",
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then((res) => {
          const { data } = res;
          setLoading(false);
          console.log(data);
          if (!data.succ) {
            setError(true);
            setMessage(data.message);
            return;
          }
          setTranx(data.resData);
        });
    } catch {
      setLoading(false);
      setError(true);
      setMessage("Failed to Fetching Data from Server");
      return;
    }
    SetisDisable(true);
  };

  const excelDownloadHandler = async (event) => {
    event.preventDefault();
    setDownloading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_HOST}v1/super/investor-report-excel`,
        {
          pan: state.folio.pan,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
          responseType: "blob",
        }
      );

      const excelFile = new Blob([response.data], {
        type: "application/octet-stream",
      });
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      saveAs(excelFile, `report-${formattedDate}.xlsx`);
    } catch (error: any) {
      setError(true);
      setErrorMessage("Cannot download reports");
      console.log(error);
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    getTranxData();
  }, []);

  const changeHandler = (name, value) => {
    setIntervalDate((prev) => ({
      ...prev,
      [name]: dateConverter(value),
    }));
  };

  return (
    <Grid container xs>
      <Grid
        item
        xs={12}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Snackbar
          open={isError}
          autoHideDuration={4000}
          onClose={() => setError(false)}
        >
          <Alert severity="error" style={{ backgroundColor: "red" }}>
            <span style={{ color: "white" }}>{message}</span>
          </Alert>
        </Snackbar>
        <AppBar
          style={{
            backgroundColor: "white",
            display: "flex",
            width: "76vw",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
          position="static"
          elevation={0}
        >
          <Toolbar
            sx={{ display: "flex", alignItems: "center", margin: "0px" }}
          >
            {/* Download Investor Report */}

            <Button
              variant="contained"
              sx={{ height: "2.5rem", marginRight: "10px" }}
              endIcon={<Download />}
              onClick={excelDownloadHandler}
            >
              Report
            </Button>
            <Datefilter
              name="startDate"
              label="From Date"
              value={IntervalDate.startDate}
              changeHandler={changeHandler}
              maxDate={Interval.endDate}
              minDate={Interval.startDate}
              inputFormat="dd-MMM-yyyy"
            />
            <Datefilter
              name="endDate"
              label="To Date"
              value={IntervalDate.endDate}
              changeHandler={changeHandler}
              maxDate={Interval.endDate}
              minDate={Interval.startDate}
              inputFormat="dd-MMM-yyyy"
            />

            {/* <DateRangePicker
                            onChange={changeHandler}
                            size='md'
                            appearance='subtle'
                            placement="bottomEnd"
                            editable={true}
                            defaultValue={[new Date(IntervalDate.startDate), new Date(IntervalDate.endDate)]}
                            showOneCalendar={true}
                            character="  to  "
                            format="dd-MM-yyyy"
                            ranges={[]}
                            cleanable={false}
                        /> */}
            <Button
              style={{ marginTop: "-3px", height: "37px" }}
              variant="contained"
              color="primary"
              onClick={getTranxData}
            >
              Search
            </Button>
          </Toolbar>
        </AppBar>

        <div style={{ height: "80vh", width: "75vw" }}>
          {loading ? (
            <Loading />
          ) : (
            <DataGrid
              sx={{ mt: 1 }}
              //  hideFooter={true}
              getRowHeight={() => "auto"}
              rowsPerPageOptions={[50, 100, 1000]}
              rows={tranx.map((each: any, idx: number) => {
                return { ...each, id: idx + 1 };
              })}
              columns={columns.map((each, idx) => {
                return {
                  id: idx + 1,
                  ...each,
                  headerAlign: "center",
                  align: "center",
                  sx: {
                    size: 2,
                  },
                };
              })}
            />
          )}
        </div>
      </Grid>
    </Grid>
  );
}
